import { useState } from 'react';
import { Table } from 'react-bootstrap';
import { Pagination } from '../ui/Pagination';
import axiosApi from '../../axios/axios-api';
import { t } from 'i18next';
import { toast } from 'react-toastify';
import { LogoPetroprix } from '../ui/LogoPetroprix';
import { AiFillCaretDown, AiFillCaretUp } from 'react-icons/ai';
import { downloadPdf } from '../../helpers/downloadPdf';
import { useDispatch } from 'react-redux';
import { ValidateToken } from '../../helpers/validateToken';
import { startLogout } from '../../store/auth';
import mini_loader from '../../assets/images/loading_anim.gif';
import download_icon from '../../assets/images/download-icon.svg';
import DownloadInvoiceIcon from '../../assets/images/DownloadInvoiceIcon';

export const TablaFacturas = ({ data, token, orderData }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  const dispatch = useDispatch();

  const nPages = Math.ceil(data.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = data.slice(indexOfFirstRecord, indexOfLastRecord);

  const URL_DOWNLOAD_FACTURAS = 'factura/descargar';

  const changeButtonsStatus = (block) => {
    if (block) {
      const downloadButtonsSpan =
        document.querySelectorAll('.factura-download');
      downloadButtonsSpan.forEach((button) => {
        button.style.pointerEvents = 'none';
      });

      const downloadWrapped = document.querySelectorAll(
        '.factura-download-ticket-span-cursor'
      );
      downloadWrapped.forEach((button) => {
        button.style.cursor = 'not-allowed';
      });
    } else {
      const downloadButtonsSpan =
        document.querySelectorAll('.factura-download');
      downloadButtonsSpan.forEach((button) => {
        button.style.pointerEvents = 'auto';
      });

      const downloadWrapped = document.querySelectorAll(
        '.factura-download-ticket-span-cursor'
      );
      downloadWrapped.forEach((button) => {
        button.style.cursor = 'pointer';
      });
    }
  };

  const downloadFile = async (num_factura, e) => {
    e.preventDefault();

    changeButtonsStatus(true);
    e.target.src = mini_loader;

    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.post(
          URL_DOWNLOAD_FACTURAS + '/' + num_factura,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token,
            },
          }
        );
        if (response?.data?.code === 200) {
          let data = response.data.data.factura;
          downloadPdf(data, num_factura, 'factura');
          changeButtonsStatus(false);
          e.target.src = download_icon;
        } else if (response?.data?.code === 404) {
          toast(t('facturas.form.table.download-error'), {
            icon: <LogoPetroprix />,
          });
          console.warn(response.data.message);
          changeButtonsStatus(false);
          e.target.src = download_icon;
        } else {
          toast(t('facturas.form.table.download-error'), {
            icon: <LogoPetroprix />,
          });
          console.warn(response.data.message);
          changeButtonsStatus(false);
          e.target.src = download_icon;
        }
      } else {
        changeButtonsStatus(false);
        e.target.src = download_icon;
        dispatch(startLogout('expired'));
      }
    } catch (error) {
      toast(t('facturas.form.table.download-error'), {
        icon: <LogoPetroprix />,
      });
      console.error(error);
    }
  };

  return (
    <>
      <Table hover={false} className='facturas' borderless={true}>
        <thead>
          <tr>
            <th>
              {t('facturas.form.table.fecha-emision')}{' '}
              <span className='order-table-icons float-end'>
                <AiFillCaretDown onClick={orderData(false, 0)} />
                <AiFillCaretUp onClick={orderData(true, 0)} />
              </span>
            </th>
            <th>
              {t('facturas.form.table.dni')}{' '}
              <span className='order-table-icons float-end'>
                <AiFillCaretDown onClick={orderData(false, 1)} />
                <AiFillCaretUp onClick={orderData(true, 1)} />
              </span>
            </th>
            <th>
              {t('facturas.form.table.importe')}{' '}
              <span className='order-table-icons float-end'>
                <AiFillCaretDown onClick={orderData(false, 2)} />
                <AiFillCaretUp onClick={orderData(true, 2)} />
              </span>
            </th>
            <th className='d-none d-lg-block'>
              {t('facturas.form.table.factura')}
              <span className='order-table-icons float-end'>
                <AiFillCaretDown onClick={orderData(false, 3)} />
                <AiFillCaretUp onClick={orderData(true, 3)} />
              </span>
            </th>
            <th>PDF</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.length > 0 ? (
            currentRecords.map((factura) => (
              <tr key={factura.id}>
                <td>{factura.fecha}</td>
                <td>{factura.nip}</td>
                <td>{factura.importe} zł</td>
                <td className='d-none d-lg-block'>{factura.folio}</td>
                <td className='factura-pdf'>
                  <span className='factura-download-ticket-span-cursor'>
                    <span
                      className='factura-download'
                      onClick={(e) => {
                        downloadFile(factura.id, e);
                      }}
                    >
                      <DownloadInvoiceIcon />
                    </span>
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} style={{ textAlign: 'center' }}>
                {t('facturas.form.table.no-results.search')}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Pagination
        nPages={nPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        recordsPerPage={recordsPerPage}
        totalRecords={data.length}
        setRecordsPerPage={setRecordsPerPage}
      />
    </>
  );
};
